module.exports = __webpack_public_path__ + "static/grammarly-64e280082582b8961e81322eac6bed20.jpg";